import moneyTier1 from '../assets/tutor-icons/final/money-tier-1.jpeg';
import moneyTier2 from '../assets/tutor-icons/final/money-tier-2.webp';
import moneyTier3 from '../assets/tutor-icons/final/money-tier-3.webp';
import moneyTier4 from '../assets/tutor-icons/final/money-tier-4-diamond.webp';
import moneyMid from '../assets/illustrations/money-mid-banknotes.webp';
import oakToast from '../assets/illustrations/oak-toast.webp';
import oakSpiceVanilla from '../assets/illustrations/oak-spice-vanilla.webp';
import wineYoung from '../assets/illustrations/wine-young.webp';
import wineAged from '../assets/illustrations/wine-aged.webp';
import wineDeveloping from '../assets/illustrations/wine-developing.webp';
import wineMature from '../assets/illustrations/wine-mature.webp';
import { tasteScaleImage } from './tasteScaleIcons';
import { grapeCardImage } from '../lib/grapeTips';

const BASE = 'https://cmrrsjwbbeurszecszhg.supabase.co/storage/v1/object/public/questionicons/';

const EXACT_IMAGE_MAP = new Map([
  ['young', wineYoung],
  ['aged', wineAged],
  ['developing', wineDeveloping],
  ['mature', wineMature],
  ['oak or toast', oakToast],
  ['oak spice and vanilla', oakSpiceVanilla],
  ['apple', BASE + 'Apple.png'],
  ['nectarine', BASE + 'Nectarine.png'],
  ['pomegranate', BASE + 'Pomegranate.png'],
  ['raspberry', BASE + 'Raspberry.png'],
  ['orange', BASE + 'Orange.png'],
  ['sour cherry', BASE + 'Sour%20cherry.png'],
  ['cherry', BASE + 'Cherry.png'],
  ['peach', BASE + 'Peach.png'],
  ['marmalade', BASE + 'Marmalade.png'],
  ['apricot', BASE + 'Apricot.png'],
  ['lemon', BASE + 'Lemon.png'],
  ['boysenberry', BASE + 'Boysenberry.png'],
  ['pineapple', BASE + 'Pineapple.png'],
  ['grapefruit', BASE + 'Grapefruit.png'],
  ['lime', BASE + 'Lime.png'],
  ['strawberry', BASE + 'Strawberry.png'],
  ['persimmon', BASE + 'Persimmon.png'],
  ['pear', BASE + 'Pear.png'],
  ['red plum', BASE + 'Red%20plum.png'],
  ['cranberry', BASE + 'Cranberry.png'],
  ['jasmine', BASE + 'Jasmine.png'],
  ['dill', BASE + 'Dill.png'],
  ['green bean', BASE + 'Green%20bean.png'],
  ['olive', BASE + 'Olive.png'],
  ['violet', BASE + 'Violet.png'],
  ['lychee', BASE + 'Lychee.png'],
  ['tomato leaf', BASE + 'Tomato%20leaf.png'],
  ['eucalyptus', BASE + 'Eucalyptus.png'],
  ['lavender', BASE + 'Lavender.png'],
  ['thyme', BASE + 'Thyme.png'],
  ['kiwi', BASE + 'Kiwi.png'],
  ['rose', BASE + 'Rose.png'],
  ['honeysuckle', BASE + 'Honeysuckle.png'],
  ['guava', BASE + 'Guava.png'],
  ['mint', BASE + 'Mint.png'],
  ['onion', BASE + 'Onion.png'],
  ['bell pepper', BASE + 'Bell%20pepper.png'],
  ['garlic', BASE + 'Garlic.png'],
  ['mango', BASE + 'Mango.png'],
  ['orange blossom', BASE + 'Orange%20blossom.png'],
  ['wet gravel', BASE + 'Wet%20gravel.png'],
  ['wet stone', BASE + 'Wet%20stone.png'],
  ['white pepper', BASE + 'White%20pepper.png'],
  ['clay pot', BASE + 'Clay%20pot.png'],
  ['leather', BASE + 'Leather.png'],
  ['truffle', BASE + 'Truffle.png'],
  ['black pepper', BASE + 'Black%20pepper.png'],
  ['slate', BASE + 'Slate.png'],
  ['chalk', BASE + 'Chalk.png'],
  ['coffee', BASE + 'Coffee.png'],
  ['baking spices', BASE + 'Baking%20spices.png'],
  ['cinnamon', BASE + 'Cinnamon.png'],
  ['anise', BASE + 'Anise.png'],
  ['jalapeño', BASE + 'Jalapeno.png'],
  ['clove', BASE + 'Clove.png'],
  ['black tea', BASE + 'Black%20tea.png'],
  ['sundried tomato', BASE + 'Sundried%20tomato.png'],
  ['tobacco', BASE + 'Tobacco.png'],
  ['mushroom', BASE + 'Mushroom.png'],
  ['five-spice', BASE + 'Five-spice.png'],
  ['cocoa', BASE + 'Cocoa.png'],
  ['smoke', BASE + 'Smoke.png'],
  ['butter', BASE + 'Butter.png'],
  ['vanilla', BASE + 'Vanilla.png'],
  ['coconut', BASE + 'Coconut.png'],
  ['cream', BASE + 'Cream.png'],
  ['yeast', BASE + 'Yeast.png'],
  ['sourdough', BASE + 'Sourdough.png'],
  ['caramel', BASE + 'Caramel.png'],
  ['brown sugar', BASE + 'Brown%20sugar.png'],
  ['raisin', BASE + 'Raisin.png'],
  ['prune', BASE + 'Prune.png'],
  ['fig', BASE + 'Fig.png'],
  ['dried fruit', BASE + 'Dried%20fruit.png'],
  ['baked fruit', BASE + 'Baked%20fruit.png'],
  ['stewed fruit', BASE + 'Stewed%20fruit.png'],
  ['blackberry', BASE + 'Blackberry.png'],
  ['blueberry', BASE + 'Blueberry.png'],
  ['black cherry', BASE + 'Black%20cherry.png'],
  ['black currant', BASE + 'Black%20currant.png'],
  ['plum', BASE + 'Plum.png'],
  ['melon', BASE + 'Melon.png'],
  ['passion fruit', BASE + 'Passion%20fruit.png'],
  ['quince', BASE + 'Quince.png'],
  ['gooseberry', BASE + 'Gooseberry.png'],
  ['honey', BASE + 'Honey.png'],
  ['date', BASE + 'Date.png'],
  ['chocolate', BASE + 'Chocolate.png'],
  ['fruitcake', BASE + 'Fruitcake.png'],
  ['nuts', BASE + 'Nuts.png'],
  ['grass', BASE + 'Grass.png'],
  ['red pepper', BASE + 'Red%20pepper.png'],
  ['fennel', BASE + 'Fennel.png'],
  ['cabbage', BASE + 'Cabbage.png'],
  ['bubblegum', BASE + 'Bubblegum.png'],
  ['lager', BASE + 'Lager.png'],
  ['balsamic', BASE + 'Balsamic%20(1).png'],
  ['vinegar', BASE + 'Vinegar%20(1).png'],
  ['cooked / oxidized', BASE + 'Cooked.png'],
  ['microbial / fermentation', BASE + 'Microbial.png'],
  ['sulphides / volatile acidity / brett', BASE + 'Sulphides.png'],
]);

const KEYWORD_MAP = [
  // Citrus first (before generic fruit) to avoid misclassification
  [/\b(lemon|lime|orange|grapefruit|citrus|mandarin|bergamot|marmalade)\b/i, BASE + 'Citrus.jpeg'],
  // Berries
  [/\b(strawberry|raspberry|blackberry|blueberry|cherry|currant|berry|cranberry|gooseberry|boysenberry|pomegranate|sour\s?cherry|red\s?plum)\b/i, BASE + 'Red berries.jpeg'],
  // Stone/tropical fruit
  [/\b(apple|pear|peach|plum|fig|mango|melon|pineapple|apricot|nectarine|quince|guava|passionfruit|lychee|kiwi|persimmon)\b/i, BASE + 'Stonefruit.jpeg'],
  // Dried/baked fruit
  [/\b(raisin|prune|dried\s?fruit|baked\s?fruit|stewed\s?fruit)\b/i, BASE + 'Driedfruit.jpeg'],
  // Spice
  [/\b(pepper|clove|cinnamon|nutmeg|vanilla|anise|licorice|spices?|peppery|cardamom|ginger|fennel|star\s?anise|five.spice|jalape[eé]?ñ?o?)\b/i, BASE + 'Spices.jpeg'],
  // Floral
  [/\b(rose|violet|jasmine|floral|blossom|lavender|elderflower|acacia|flower|hibiscus|honeysuckle|orange\s?blossom)\b/i, BASE + 'floral.jpeg'],
  // Herb / Vegetal
  [/\b(grass|mint|eucalyptus|thyme|basil|sage|herb|herbal|green|tomato|olive|asparagus|capsicum|dill|onion|garlic|bell\s?pepper|green\s?bean|sundried|tomato\s?leaf)\b/i, BASE + 'Herbal.jpeg'],
  // Earth / Mineral
  [/\b(earth|mineral|slate|flint|chalk|earthy|soil|stone|gravel|mushroom|truffle|leather|tobacco|tar|clay|black\s?tea)\b/i, BASE + 'Earthy.jpeg'],
  // Wood / Oak / Smoke
  [/\b(oak|cedar|smoke|wood|smoky|toasted|charcoal|coffee|cocoa|chocolate|mocha)\b/i, BASE + 'Oak or toast.jpeg'],
  // Dairy / Baked / Nuts
  [/\b(cream|butter|milk|brioche|bread|yeast|toast|biscuit|caramel|honey|toffee|coconut|sourdough|brown\s?sugar|nut|nutty)\b/i, BASE + 'Cream.jpeg'],
  [/\bbubblegum\b/i, BASE + 'Bubblegum.png'],
  [/\blager\b/i, BASE + 'Lager.png'],
  // Fault notes
  [/\b(burnt\s?rubber|balsamic|vinegar|band.?aid|horse\s?blanket|barnyard|sweat|cabbage)\b/i, BASE + 'Barnyard.png'],
];

/**
 * Returns the UNIQUE per-flavor icon URL for an exact flavor name, or null.
 * Only consults EXACT_IMAGE_MAP — never the broad KEYWORD_MAP category icons.
 * Use this to prefer a flavor's own icon over an admin-assigned category icon.
 */
export function exactFlavorImage(word) {
  if (!word) return null;
  return EXACT_IMAGE_MAP.get(word.trim().toLowerCase()) || priceBandImage(word);
}

// Use each band's lower bound to select distinct accessories. Banknotes mark
// R200–R300; the diamond is reserved for R300+.
function priceBandImage(text) {
  const t = String(text).trim();
  if (/^under\s*R\s*\d/i.test(t)) return moneyTier1;
  const m = t.match(/^R\s*(\d[\d\s,]*)\s*(\+|[–-]\s*R\s*\d[\d\s,]*)\s*$/i);
  if (!m) return null;
  const low = Number(m[1].replace(/[\s,]/g, ''));
  if (low >= 300) return moneyTier4;
  if (low >= 200) return moneyMid;
  if (low >= 150) return moneyTier3;
  if (low >= 100) return moneyTier2;
  return moneyTier1;
}

/**
 * Returns an emoji string for a single flavor keyword, or null if unknown.
 */
export function flavorEmoji(word) {
  const exactImage = EXACT_IMAGE_MAP.get(word.trim().toLowerCase());
  if (exactImage) return exactImage;

  for (const [pattern, emoji] of KEYWORD_MAP) {
    if (pattern.test(word)) return emoji;
  }
  return null;
}

/**
 * Given an option label and its metadata, returns an array of icon descriptors.
 * Each descriptor is either an image URL (string starting with 'http') or an emoji char.
 */
export function deriveIcons(optionText, meta = {}) {
  // 1. Comma-separated option text → one icon per part (prefers unique via flavorEmoji)
  const parts = optionText.split(',').map((s) => s.trim()).filter(Boolean);
  if (parts.length > 1) {
    const icons = parts.map((part) => flavorEmoji(part)).filter(Boolean);
    if (icons.length > 0) return icons;
  }

  // 2. Single flavor with a UNIQUE library icon → always prefer it over a
  //    category icon that may have been hand-assigned in the admin metadata.
  const exact = exactFlavorImage(optionText);
  if (exact) return [exact];

  // 2b. Acidity / body / sweetness options: drawn scale icons, matched on label + stored photo.
  const scale = tasteScaleImage(optionText, meta.image);
  if (scale) return [scale];

  // 2c. A known grape variety gets its own vine-leaf card instead of the
  //     shared white/red glass stored in the metadata.
  const grape = grapeCardImage(optionText);
  if (grape) return [grape];

  // 3. Explicit images array from admin data
  if (Array.isArray(meta.images) && meta.images.length > 0) {
    return meta.images;
  }

  // 4. Single image from meta
  if (meta.image) return [meta.image];

  return [];
}

// Swatch hexes progress red → brown/amber → white → yellow → green, roughly
// matching how a wine ages/lightens. Keep neighbours distinguishable.
const WINE_COLOUR_HEX = {
  'garnet': '#4F021B', 'ruby': '#9B1B30', 'pale ruby': '#B8455A', 'deep ruby': '#6B0F1A', 'purple': '#7C1034',
  'deep purple': '#4A0E2E',
  // TAS-205: tawny is a brick/amber-brown (an ageing red browning at the rim),
  // NOT the near-black red it used to be (#6B0E11, a dup of 'deep ruby' that
  // read purple). Kept redder than 'amber'/'copper' so it stays distinct.
  'tawny': '#9A431F', 'brown': '#6F4320', 'deep amber': '#A8610F', 'amber': '#C47A1E',
  'copper': '#B87333', 'orange': '#D2691E',
  'pink': '#F4BEC0', 'rosé': '#F4A5B0', 'rose': '#F4A5B0', 'pale salmon': '#F2B5A6', 'salmon': '#E8847A',
  'white': '#F5F0DC', 'straw': '#E8D96A', 'pale straw': '#F0E7B4', 'pale lemon': '#F3EC9B', 'lemon': '#EFE36A',
  'pale gold': '#E6CF72', 'gold': '#D4AF37', 'deep gold': '#C9981E', 'light yellow': '#F5EAA0',
  'pale yellow': '#F5EAA0', 'yellow': '#F0D060', 'lemon-green': '#DDE08A', 'green': '#B8C97A',
};

export function wineColourSwatch(name) {
  const hex = WINE_COLOUR_HEX[(name || '').toLowerCase().trim()];
  if (!hex) return null;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><circle cx="50" cy="50" r="50" fill="${hex}"/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
